@if (item?.children) {
  @if (canShowParent(item)) {
    <mat-list-item
      class="nav-item nav-item--parent"
      [title]="item.label"
      [attr.aria-label]="item.label"
      >
      @if (item.iconClass) {
        <div [ngClass]="['icon', item.iconClass]"></div>
      }
      @if (!compact) {
        <span class="nav-item-label">{{item.label}}</span>
      }
    </mat-list-item>
  }
}

@if (item && !item.children) {
  @if (item.canShow()) {
    <mat-list-item
      class="nav-item"
      [title]="item.label"
      [attr.aria-label]="item.label"
      [routerLink]="item.routerLink"
      [queryParams]="item.routerLinkParams"
      routerLinkActive="nav-item--active"
      >
      @if (item.iconClass) {
        <div [ngClass]="['icon', item.iconClass]"></div>
      }
      @if (!compact) {
        <span class="nav-item-label">{{item.label}}</span>
      }
    </mat-list-item>
  }
}
